import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDashboardSSO } from '../../actions/dashboard';
import Iframe from '../common/Iframe';

// TODO: refactor to function component and make it properly handle re-rendering with changed dashboardId
// right now parent components have to workaround with "key" prop
export class LookerDashboard extends React.PureComponent {
  state = {};

  componentDidMount() {
    const { getDashboardSSO, dashboardId, type, shopId } = this.props;
    getDashboardSSO(shopId, dashboardId, type);
  }

  onLoad = () => {
    this.setState({ iframeIsLoaded: true });
  };

  render() {
    const { ssoUrl, isLoading, loaded, error } = this.props;
    const { iframeIsLoaded } = this.state;
    const showLoader = isLoading || (!error && !iframeIsLoaded);

    return <Iframe onLoad={this.onLoad} pageUrl={ssoUrl} showLoader={showLoader} showIframe={loaded} />;
  }
}

LookerDashboard.defaultProps = {
  type: 'dashboard',
};

LookerDashboard.propTypes = {
  dashboardId: PropTypes.string.isRequired,
  type: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
    getDashboardSSO: (shopId, dashboardId, type) => dispatch(getDashboardSSO(shopId, dashboardId, type)),
  };
}

function mapStateToProps(state) {
  const {
    lookerDashboard: { id, name, ssoUrl, error, isLoading, loaded },
    user: { selectedShopId: shopId },
  } = state;

  return {
    id,
    name,
    ssoUrl,
    error,
    isLoading,
    loaded,
    shopId,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LookerDashboard);
